<template>
  <v-container :class="$vuetify.breakpoint.width < 1264 ? 'billing-container px-10' : 'billing-container pl-12 pr-4'">
    <v-row class="billing-title mb-4">{{ $t('billing') }}</v-row>
    <v-row class="billing-desc">{{ $t('billingInfo') }}</v-row>
    <v-row
      @click="openCustomerPortal"
      :class="isCompleteLoading ? 'billing-link mt-10' : 'billing-link-disabled mt-10'"
    >
      {{ $t('openCustomerPortal') }}
    </v-row>
  </v-container>
</template>

<script>
import { getCustomerPortalUrl } from '@/services/stripe'
import { mapGetters } from 'vuex'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'BillingSetting',
  created() {
    this.getCustomerPortalUrl()
  },
  data() {
    return {
      portalUrl: '',
      isCompleteLoading: false,
    }
  },
  methods: {
    async getCustomerPortalUrl() {
      try {
        if (this.selectedWsInfo && this.selectedWsInfo['stripeSubId'] && this.selectedWsInfo['stripeSubId'] !== '') {
          let returnUrl = `${location.origin}/${this.selectedWsInfo['wsDomain']}/my`

          let result = await getCustomerPortalUrl(this, this.selectedWsInfo['stripeSubId'], returnUrl)
          this.portalUrl = result['portalUrl']
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isCompleteLoading = true
      }
    },
    async openCustomerPortal() {
      if (this.isCompleteLoading && this.portalUrl && this.portalUrl !== '') {
        location.replace(this.portalUrl)
      } else if (this.isCompleteLoading) {
        // notify(this, 'Error', this.$t('openCustomerPortalErrMsg'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('openCustomerPortalErrMsg'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
  },
  computed: {
    ...mapGetters(['selectedWsInfo']),
  },
}
</script>

<style scoped>
.billing-container {
  background-color: #21343b;
}
.billing-title {
  color: #eee;
  font-weight: 700;
}
.billing-desc {
  color: #96a7af;
  font-weight: 400;
  font-size: 14px;
}
.billing-link {
  display: block;
  width: 100%;
  color: #25c685;
  font-weight: 600;
  font-size: 14px;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}
.billing-link-disabled {
  display: block;
  width: 100%;
  color: #475e69;
  font-weight: 600;
  font-size: 14px;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}
</style>
